import { axiosIns } from "../utils";

export const fetchFormationLevels = async () => {
  const response = await axiosIns.get("/formation-level/");
  return response && response.data ? response.data : response;
};

export const createFormationLevelApi = async (payload) => {
  const response = await axiosIns.post("/formation-level/", payload);
  return response && response.data ? response.data : response;
};

export const updateFormationLevelApi = async (id, payload) => {
  const response = await axiosIns.patch(`/formation-level/${id}/`, payload);
  return response && response.data ? response.data : response;
};

export const deleteFormationLevelApi = async (id) => {
  const response = await axiosIns.delete(`/formation-level/${id}/`);
  return response && response.data ? response.data : response;
};
